import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
// store
import {
	setCardsData,
	clearFilterType,
	setLoading,
} from "../../configureStore";

const Card = (props) => {
	const [activeCard, setActiveCard] = useState(false);
	const searchData = useSelector((state) => state.searchData);
	const dispatch = useDispatch();
	useEffect(() => {
		const searchParams = new URLSearchParams(window.location.search);
		const cards = searchParams.getAll("cards");
	
    
		if (cards.length) {
			cards.forEach((card) => {
				if (card == props.card.cardId) {
					setActiveCard(true);
				}
			});
		}
    // if none of the cards are checked
		if (props.card.allowedForDiscounts && !cards.length) {
			setActiveCard(true);
			dispatch(setCardsData({ card: props.card.cardId, type: "add" }));
		}
	}, []);
  
	const toggleCard = async (e, id) => {
		const cardCheckbox = e.target;
		let type = "";
		if (cardCheckbox.checked) {
			type = "add";
		} else {
			type = "remove";
			// remove discounts from filters if discount card is unchecked
			if (props.card.allowedForDiscounts) {
				dispatch(clearFilterType("discountCategory"));
			}
		}
		setActiveCard(false);
		await dispatch(setCardsData({ card: id, type: type }));
		dispatch(setLoading(true));
	};
	// check if  url has params or filters were removed from pills
	const setCheckStatus = (id) => {
		if (activeCard) {
			return true;
		}
		return searchData.cards.some((el) => el === id);
	};
	return (
		<label
			htmlFor={props.card.name + props.card.cardId}
			aria-label={props.card.name}
			className="card">
			<input
				type="checkbox"
				className="card__control"
				checked={setCheckStatus(props.card.cardId)}
				onChange={(e) => toggleCard(e, props.card.cardId)}
				name={props.card.name + props.card.cardId}
				id={props.card.name + props.card.cardId}
			/>
			<img
				src={props.card.thumbnailURL}
				className="card__img"
				alt={props.card.name}
			/>
			<span className="card__check"></span>
		</label>
	);
};

export default Card;
